import React, { Component } from "react";
import Footer from "../footer/footer";
import HeaderNew from "../header/header";
import { Link } from "react-router-dom";
import pic from '../assets/pr.jpg';
import dots from "../assets/dots.png"
import mailicon from '../assets/mail.png'
import load from '../assets/loading.gif'
import pen from "../assets/pen.png"
import rem from "../assets/close.png"
import { List } from 'react-content-loader'


import './profile.css'
import Axios from "axios";
import { BASE } from "../api/api";
import OutsideClickHandler from "react-outside-click-handler";

class Profile extends Component {
    constructor() {
        super()
        this.updateFile = React.createRef();
        this.state = {
            tabselect: 'overview',
            edit: false,
            user: [],
            works: [],
            included: [],
            afflsuggs: [],
            mail: "",
            city: '',
            country: "",
            occupation: "",
            number: "",
            name: "",
            fname: "",
            lname: "",
            prefix: ""
        }
    }
    componentDidMount() {
        // Axios.get(`${BASE}filter[artist][condition][path]=name&filter[artist][condition][value]=al&filter[artist][condition][operator]=CONTAINS`)
        // .then(data=>{
        //     console.log()
        // })
        if (localStorage.getItem('token'))
            this.checkexpiry()
        else {
            this.props.history.push("/login")
        }
        Axios.get(`${BASE}jsonapi/user/user/${localStorage.getItem('uid')}?include=field_affiliation,user_picture`, {
            headers: {
                "Content-Type": "application/vnd.api+json",
                "Authorization": `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then(data => {
                console.log("user-details", data.data)
                this.setState({
                    user: data.data.data,
                    name: data.data.data.attributes.name,
                    mail: data.data.data.attributes.mail,
                    occupation: data.data.data.attributes.field_occupation,
                    bio: data.data.data.attributes.field_bio ? data.data.data.attributes.field_bio.value : null,
                    prefix: data.data.data.attributes.field_prifix,
                    fname: data.data.data.attributes.field_first_name,
                    lname: data.data.data.attributes.field_last_name,
                    target: data.data.data.attributes.drupal_internal__uid
                })
                if (!data.data.data.attributes.mail) {
                    this.signout()
                }
                //data.relationships.field_affiliation.data.id
                if (data.data.data.relationships.field_affiliation.data) {
                    let author
                    author = data.data.included.filter(x => x.id === data.data.data.relationships.field_affiliation.data.id)[0].attributes.name
                    console.log('affiliation', author)
                    this.setState({
                        affiliation: author
                    })
                }
                //data.relationships.user_picture.data.id
                if (data.data.data.relationships.user_picture.data) {
                    let author
                    author = data.data.included.filter(x => x.id === data.data.data.relationships.user_picture.data.id)[0].attributes.uri.url
                    console.log('picture', author)
                    this.setState({
                        picture: BASE + author
                    })
                }
            })
            .catch(err => {
                console.log('user error', err.message)
            })
        this.getworks()

    }
    getworks() {
        this.setState({
            works: null,
            included: []
        })
        Axios.get(`${BASE}jsonapi/node/submit_for_work?include=uid,field_select_work_to_submit&filter[uid][condition][path]=uid.id&filter[uid][condition][value]=${localStorage.getItem('uid')}`,
            {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('token')}`
                }
            })
            .then(data => {
                console.log("works", data.data)
                this.setState({
                    works: data.data.data,
                    included: data.data.included
                })
            })
            .catch(err => {
                console.log('Get work error:', err.message)
            })
    }
    clear() {
        let i
        for (i = 0; i < this.state.works.length; i++) {
            this.setState({
                [i]: false
            })
        }
    }
    getAffl() {
        // Axios.get(``)
    }
    open(data) {
        let i
        for (i = 0; i < this.state.works.length; i++) {
            this.setState({
                [i]: false
            })
        }
        this.setState({
            [data]: true
        })
    }
    checkexpiry() {
        console.log("checking expiry")
        if (localStorage.getItem('expiryref')) {
            let expref = Date.parse(localStorage.getItem('expiryref'))
            let s = new Date();
            if (s > expref) {
                this.fillalert('Session Expired!Logging Out')
                this.signout()
            }
            else {
                this.refreshexp()
            }

        }
        else {
            this.fillalert('Session Expired!Logging Out')
            this.signout()

        }
    }
    signout() {
        localStorage.removeItem('token');
        localStorage.removeItem('expirytime');
        localStorage.removeItem('expiryref');
        this.props.history.push('/login');
    }
    refreshexp() {
        let s = new Date();
        s.setSeconds(s.getSeconds() + 1800);
        localStorage.setItem('expiryref', s)
    }
    fillalert(msg) {
        this.setState({
            fillalert: true,
            filltext: msg ? msg : ''
        })
        setTimeout(
            function () {
                this.setState({
                    fillalert: null,
                    filltext: ''
                })
            }
                .bind(this),
            3000
        );
    }
    profile_edit() {
        this.setState({
            load: true
        })
        const body = {
            "data": {
                "type": "user--user",
                "id": localStorage.getItem('uid'),
                "attributes": {
                    "mail": this.state.mail ? this.state.mail : "",
                    "field_city": this.state.city ? this.state.city : "",
                    "field_country": this.state.country ? this.state.country : "",
                    "field_occupation": this.state.occupation ? this.state.occupation : "",
                    "field_bio": this.state.bio ? this.state.bio : "",
                    "field_phone_number": this.state.number ? this.state.number : "",
                    "field_prifix": this.state.prefix ? this.state.prefix : ""
                },
                "relationships": {
                    "user_picture": {
                        "data": this.state.upimg ? {
                            "type": "file--image",
                            "id": this.state.upimg
                        } : null
                    },
                    "field_affiliation": {
                        "data": this.state.afflid ? {
                            "type": "taxonomy_term--affiliations",
                            "id": this.state.afflid
                        } : null
                    }
                }
            }
        }
        Axios.patch(`${BASE}jsonapi/user/user/${localStorage.getItem('uid')}?sort[sort-created][path]=created&sort[sort-created][direction]=DESC`, body,
            {
                headers: {
                    "Content-Type": "application/vnd.api+json",
                    "Accept": "application/vnd.api+json",
                    "Authorization": `Bearer ${localStorage.getItem('token')}`
                }
            })
            .then(data => {
                console.log(data.data)
                this.setState({
                    load: false,
                    edit: false
                })
                this.fillalert("Edit Done")
            })
            .catch(err => {
                this.fillalert('Error on Edit: ', err.message)
                this.setState({
                    load: false,
                    edit: false
                })
            })
    }
    delete_pub(id, index) {
        this.setState({
            [index]: false
        })
        console.log('to edit', id)
        Axios.delete(`${BASE}jsonapi/node/submit_for_work/${id}`, {
            headers: {
                "Content-Type": "application/vnd.api+json",
                "Authorization": `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then(data => {
                console.log("Delete is Success", data.data)
                this.fillalert("Deleted")
                this.getworks()
            })
            .catch(err => {
                console.log('Error on Deletion:', err.message)
                this.fillalert("Error on Deletion")
                if (err.response.status === 403) {
                    alert('Session Expired.Please Login')
                    localStorage.removeItem('token');
                    this.props.history.push('/login?redir=/profile')
                }
                else {
                    console.log('Error on Deletion:', err.message)
                    this.fillalert("Error on Deletion")
                }
            })
    }
    selectFiles() {
        this.updateFile.current.click();
    }
    handleFile(event) {
        const history = this.props.history
        const stop = this
        event.stopPropagation();
        event.preventDefault();
        let selectedFile = event.target.files;
        let file = null;
        let fileName = "";
        let target = this.state.target
        this.setState({
            load: true
        })
        //Check File is not Empty
        if(event.target.files[0].size> 2097152){
            this.fillalert("Max image size should be 2MB")
            console.log("image size",event.target.files[0].size)
            this.setState({
                load: false
            })
        }
        else if (selectedFile.length > 0) {
            // Select the very first file from list
            let fileToLoad = selectedFile[0];
            fileName = fileToLoad.name;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                file = fileLoadedEvent.target.result.split(',')[1];
                // Print data in console
                console.log('file to upload', file);

                const formbody = {
                    "_links": {
                        "type": {
                            "href": "https://ibir-api.hbku.edu.qa/rest/type/file/document"
                        }
                    },
                    "filename": [
                        {
                            "value": fileName
                        }
                    ],
                    "filemime": {
                        "value": "image/png"
                    },
                    "uid": [
                        {
                            "target_id": target,
                            "target_type": "user",
                            "target_uuid": localStorage.getItem('uid'),
                            "url": "/user/806"
                        }
                    ],
                    "uri": [
                        {
                            "value": `public://${fileName}`
                        }
                    ],
                    "type": {
                        "target_id": "file"
                    },
                    "data": [
                        {
                            "value": file
                        }
                    ]
                }
                Axios({
                    url: BASE + "entity/file?_format=hal_json",
                    method: "POST",
                    headers: {
                        "X-CSRF-Token": "Isqh8xGZPB7Pf8kW8mY7eyQWLNaXGebdRCcU1XPK3LA",
                        "Content-Type": "application/hal+json",
                        "Authorization": "Basic YWRtaW46M2RtaW4="
                    },
                    data: formbody
                }).then((data) => {
                    console.log("img upload done", data.data)
                    stop.setState({
                        load: false,
                        upimg: data.data.uuid[0].value,
                        picture: BASE + data.data.uri[0].url
                    })
                }).catch((data) => {
                    stop.setState({
                        load: false
                    })
                    console.log('error upload', data.message)
                    this.fillalert(data.message)
                })
            };
            // Convert data to base64
            fileReader.readAsDataURL(fileToLoad);
        }
        console.log('file after convert', file, ",name:", fileName);
    }
    checkaffl(id) {
        Axios.get(`${BASE}jsonapi/taxonomy_term/affiliations?filter[artist][condition][path]=name&filter[artist][condition][value]=${id}&filter[artist][condition][operator]=CONTAINS`)
            .then(data => {
                console.log("affl-list", data.data.data)
                this.setState({
                    afflsuggs: data.data.data
                })
            })
    }
    render() {
        const profile = {
            "name": "Danny Sapio",
            "bio": "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
            "profession": "Counsillor",
            "affiliation": 'Oxford University, UK',
            "email": "dannysapio@gmail.com"
        }
        return (
            <div>
                {this.state.load ? <div className='loading'>
                    <img src={load} alt='load' />
                </div> : ''}
                {this.state.fillalert ? <div className={this.state.filltext === 'Edit Done' || this.state.filltext === 'Deleted' ? "fill-alert fill-success" : "fill-alert"}>{this.state.filltext ? this.state.filltext : 'Please enter all mandatory fields'}</div> : ''}

                <HeaderNew />
                <div className='container'>
                    <div className='row-profile'>
                        <div className='img-cont editable-content'>
                            <div className='width-90'>
                                <div className="image-space">
                                    {this.state.picture ? <img src={this.state.picture} className='profile-img' /> : <img src={pic} className='profile-img' />}
                                    {this.state.edit ? <div className="edit-img">
                                        <img src={pen} className="pen pointer" onClick={() => this.selectFiles()} onMouseEnter={() => this.setState({ showedit: true })} onMouseLeave={() => this.setState({ showedit: false })} />
                                        <img src={rem} className="pointer" onClick={() => this.setState({ upimg: null, picture: "" })} onMouseEnter={() => this.setState({ showrem: true })} onMouseLeave={() => this.setState({ showrem: false })} />
                                        {this.state.showedit ? <p className='show'>Edit</p> : ""}
                                        {this.state.showrem ? <p className='show'>Remove</p> : ""}
                                    </div> : ""}
                                </div>
                                <input type='file' id='file' ref={this.updateFile} accept="image/png, image/gif, image/jpeg" style={{ display: 'none' }} onChange={(e) => this.handleFile(e)} />
                                <div className='profile-name'><span>{this.state.fname && this.state.lname ? this.state.fname : this.state.name} </span><span> {this.state.lname}</span></div>
                                <p className='profile-details'>{this.state.bio ? this.state.bio : ""}</p>
                                <p className='profile-affl'>{this.state.occupation} {this.state.occupation ? " at " : ""} {this.state.affiliation}</p>
                                {this.state.user ? this.state.user.attributes ? this.state.user.attributes.mail ? <a href={this.state.user.attributes.mail}><img className='mailicon' src={mailicon} />  {this.state.user.attributes.mail}</a> : "" : '' : ""}
                                <div className='edit-prof' onClick={() => this.setState({ edit: true, tabselect: "overview" })}>Edit Profile</div>
                            </div>
                        </div>
                        <div className="other-cont">
                            <div className='profile-tab'>
                                <div className='tabselect' onClick={() => this.setState({ tabselect: 'overview' })} style={{ borderBottomColor: this.state.tabselect === 'overview' ? "#165E84" : "", color: this.state.tabselect === "overview" ? "#165E84" : "", fontWeight: this.state.tabselect === "overview" ? "500" : "400" }}>Profile Overview</div>
                                <div className='tabselect' onClick={() => this.setState({ tabselect: 'publications' })} style={{ borderBottomColor: this.state.tabselect === 'publications' ? "#165E84" : "", color: this.state.tabselect === "publications" ? "#165E84" : "", fontWeight: this.state.tabselect === "publications" ? "500" : "400" }}>Publications</div>
                                {/* <Link to="/claim_your_work" className='submit-work'><p>Claim Your Work</p></Link> */}
                                <Link to="/submit_your_work/select" className='submit-work'><p>Submit Your Work</p></Link>
                            </div>
                            {this.state.tabselect === "overview" ? <div className='form-container'>
                                <p className='form-head'>About me</p>
                                <div className='form-data'>
                                    <div className='data-column'>
                                        <div className='rows name-row'>
                                            <p className="label">Prefix</p>
                                            <p className='label'>First Name</p>
                                        </div>
                                        <div className='rows name-row'>
                                            <select name="prefix" className='box select-box' style={{ paddingLeft: this.state.prefix === "Prof." ? "0.4%" : "1%" }} value={this.state.prefix} onChange={(e) => this.setState({ prefix: e.target.value })} disabled={!this.state.edit}>
                                                <option value={this.state.prefix}>{this.state.prefix}</option>
                                                <option disabled={this.state.prefix === "Dr."} value="Dr.">Dr.</option>
                                                <option disabled={this.state.prefix === "Prof."} value="Prof.">Prof.</option>
                                                <option disabled={this.state.prefix === "Mr."} value="Mr.">Mr.</option>
                                                <option disabled={this.state.prefix === "Ms."} value="Ms.">Ms.</option>
                                            </select>
                                            <input disabled={!this.state.edit} className='box' onChange={(e) => this.setState({ fname: e.target.value })} value={this.state.fname} ></input>
                                        </div>
                                    </div>
                                    <div className='data-column'>
                                        <p className='label'>Last Name</p>
                                        <input disabled={!this.state.edit} className='box' onChange={(e) => this.setState({ lname: e.target.value })} value={this.state.lname} ></input>
                                    </div>
                                    <div className='data-column'>
                                        <p className='label'>Bio</p>
                                        <input disabled={!this.state.edit} className='box' onChange={(e) => this.setState({ bio: e.target.value })} value={this.state.bio} ></input>
                                    </div>
                                    <div className='data-column'>
                                        <p className='label'>Position</p>
                                        <input disabled={!this.state.edit} className='box' onChange={(e) => this.setState({ occupation: e.target.value })} value={this.state.occupation}></input>
                                    </div>
                                    <div className='data-column' style={{ position: "relative" }}>
                                        <p className='label'>Current Affiliation</p>
                                        <input disabled={!this.state.edit} className='box' onChange={(e) => { this.checkaffl(e.target.value); this.setState({ affiliation: e.target.value }) }} value={this.state.affiliation}></input>
                                        {this.state.afflsuggs.length ?
                                            <div className="suggs-cont">
                                                {this.state.afflsuggs.map((data) => {
                                                    return (
                                                        <div className="pointer" onClick={() => this.setState({ affiliation: data.attributes.name, afflid: data.id, afflsuggs: [] })}>
                                                            {data.attributes.name}
                                                        </div>
                                                    )

                                                })}
                                            </div>
                                            : ""}

                                    </div>

                                    <div>

                                    </div>
                                    <div className='data-column'>
                                        <p className='label'>Email</p>
                                        <input disabled={!this.state.edit} className='box' onChange={(e) => this.setState({ mail: e.target.value })} value={this.state.mail}></input>
                                    </div>
                                    {this.state.edit ? <div className='save-btn' onClick={() => this.profile_edit()}>Save</div> : ""}
                                </div>
                            </div>
                                : ""}
                            {this.state.tabselect === "publications" ? <div className='pub-container'>
                                <div className='table'>
                                    <div className='row-head thead'>
                                        <div className='title'>Title</div>
                                        <div className='other'>Work</div>
                                        <div className='other'>Date of submission</div>
                                        <div className='other'>Status</div>
                                    </div>
                                    {this.state.works ? this.state.works.length ? this.state.works.map((data, index) => {
                                        let work
                                        if (data.relationships.field_select_work_to_submit.data) {
                                            work = this.state.included.filter(x => x.id === data.relationships.field_select_work_to_submit.data.id)[0].attributes.name
                                        }
                                        return (
                                            <div className='table-data row-head'>
                                                <div className='title'>{data.attributes ? data.attributes.title ? data.attributes.title : "" : ""}</div>
                                                <div className='other'>{work ? work : ""}</div>
                                                <div className='other'>{data.attributes ? data.attributes.created ? (new Date(data.attributes.created).getDate() >= 9 ? new Date(data.attributes.created).getDate() : "0" + new Date(data.attributes.created).getDate()) + "." + ((new Date(data.attributes.created).getMonth() + 1 >= 9 ? new Date(data.attributes.created).getMonth() + 1 : "0" + (new Date(data.attributes.created).getMonth() + 1))) + "." + new Date(data.attributes.created).getFullYear() : "" : ""}</div>
                                                <div className='other capitalize'>{data.attributes ? data.attributes.field_status ? data.attributes.field_status : "Pending" : "Pending"}</div>
                                                <div className='dots' >
                                                    <img src={dots} onClick={() => this.open(index)} />
                                                    {this.state[index] ? <div>
                                                        <OutsideClickHandler onOutsideClick={() => this.clear()}>
                                                            <div className='up-arrow'>
                                                            </div>
                                                            <div className='edit-box'>
                                                                <Link to={`/edit_your_work/${data.id}`} onClick={() => this.props.history.push(`/edit_your_work/${data.id}`)}>Edit</Link>
                                                                <p onClick={() => this.delete_pub(data.id, index)}>Delete</p>
                                                            </div>

                                                        </OutsideClickHandler>
                                                    </div>
                                                        : ""}
                                                </div>
                                            </div>
                                        )
                                    })
                                        : <p className='no-pub'>No Publications Submitted</p> : <List />}
                                </div>
                            </div>
                                : ""}
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export default Profile;